import { useCallback, useEffect, useRef, useState } from 'react';
import WebAudio from './webAudio';

export interface IUseWebAudioResult extends Omit<WebAudio, 'play'> {
  /** 是否正在播放 */
  isPlay: boolean;
  play: (buffer: ArrayBuffer, id: symbol) => Promise<boolean>;
  playId?: symbol;
}

const useWebAudio = (): IUseWebAudioResult => {
  const audioRef = useRef<WebAudio>({} as WebAudio);
  const [playId, setPlayId] = useState<symbol>();
  const [isPlay, setIsPlay] = useState<boolean>(false);

  // 同步代码执行初始化和事件监听
  useEffect(() => {
    const unPaly = () => {
      setIsPlay(false);
    };
    const paly = () => {
      setIsPlay(true);
    };

    audioRef.current = new WebAudio();

    audioRef.current.addEventListener('onComplete', unPaly);
    audioRef.current.addEventListener('onEnded', unPaly);
    audioRef.current.addEventListener('onSuspend', unPaly);
    audioRef.current.addEventListener('onError', unPaly);

    audioRef.current.addEventListener('onPlay', paly);
    audioRef.current.addEventListener('onResume', paly);

    return () => {
      audioRef.current.removeEventListener('onComplete', unPaly);
      audioRef.current.removeEventListener('onEnded', unPaly);
      audioRef.current.removeEventListener('onSuspend', unPaly);
      audioRef.current.removeEventListener('onError', unPaly);

      audioRef.current.removeEventListener('onPlay', paly);
      audioRef.current.removeEventListener('onResume', paly);
    };
  }, []);

  useEffect(() => {
    return () => {
      audioRef.current.close();
    };
  }, []);

  const play = useCallback((buffer: ArrayBuffer, id: symbol) => {
    setPlayId(id);
    return audioRef.current.play(buffer);
  }, []);

  return {
    isPlay,
    ...audioRef.current,
    play,
    playId: playId
  };
};

export default useWebAudio;
